import { Roles } from '../../utils/enums'
import { Http } from '../../utils/types'
import { GetBlob, ObjectGeneric } from '../../utils/types/generals'
import { getUserRole } from '../auth'
import {
  CreateOrUpdateResponse,
  OptionGroupResponse,
  PermissionQuestionnaireResponse,
  QuestionTree,
  QuestionTypesResponse,
  QuestionaireVersion,
  QuestionnaireByIdResponse,
  QuestionnaireListOld,
  QuestionnaireListResponse,
  QuetionarieDetail,
  QuestionsByQuestionnaireResponse,
} from './response'

export const questionarieServise = (client: Http) => {
  return {
    getAllQuestionaries: async (): Promise<QuestionnaireListOld> => {
      switch (getUserRole()) {
        case Roles.ADMIN:
          return await client.get(`questionnaires/filters`)
        default:
          return await client.get('questionnaires/?is_scheduled=false')
      }
    },
    getQuestionnairesWithVersions: async (params?: {
      company_id?: string
      date_init?: string
      date_end?: string
      year?: number
      weeks?: string
    }): Promise<QuestionnaireListOld> => {
      const parts: string[] = []
      if (params?.company_id) parts.push(`company_id=${params.company_id}`)
      if (params?.date_init) parts.push(`date_init=${params.date_init}`)
      if (params?.date_end) parts.push(`date_end=${params.date_end}`)
      if (params?.year) parts.push(`year=${params.year}`)
      if (params?.weeks) parts.push(`weeks=${params.weeks}`)
      const query = parts.length > 0 ? `?${parts.join('&')}` : ''
      return await client.get(`questionnaires/versions${query}`)
    },
    getTableQuestionnaires: async ({ query }: { query?: string }): Promise<QuestionnaireListResponse> => await client.get(`questionnaires/detailed${query ? '?' + query : ''}`),
    getQuestionariesByUser: async (ids: number | string) =>
      await client.get(`questionnaires/users?users=${ids}`),
    getAllQuestionariesOld: async ({ type }: { type: boolean }): Promise<QuestionnaireListOld> => {
      return await client.get(`questionnaires?is_scheduled=${type}`)
    },
    downloadTemplate: async (data: {
      type: `pdf` | 'word' | 'excel'
      query?: string
    }): Promise<GetBlob> =>
      await client.getBlob?.(
        `questionnaires/generate-file?type=${data.type}${data?.query ? `${data?.query}` : ''
        }`
      ),
    getQuestionarieById: async (
      id: number | string
    ): Promise<QuestionnaireByIdResponse> =>
      await client.get(`questionnaires/${id}`),
    getQuestionsByQuestionnaireId: async (
      id: number | string
    ): Promise<QuestionsByQuestionnaireResponse> =>
      await client.get(`questionnaires/questions/${id}`),
    copyByOtherQuestionnarie: async (body: ObjectGeneric | FormData) =>
      await client.post('questionnaires/copy-questionnaire', body),
    getOptionGroup: async (type:number): Promise<OptionGroupResponse> => await client.get(`option-group?type=${type}`),
    getOptionGroupTree: async (id:number): Promise<QuestionTree> => await client.get(`option-group/detailed-tree/${id}`),
    getQuestionType: async ():Promise<QuestionTypesResponse> => await client.get('question-type'),
    getEvidenceType: async () => await client.get('evidence-type'),
    createQuestionnarie: async (
      body: ObjectGeneric
    ): Promise<CreateOrUpdateResponse> =>
      await client.post('questionnaires', body),
    updateQuestionnarie: async (
      id: string,
      body: ObjectGeneric
    ): Promise<CreateOrUpdateResponse> =>
      await client.put(`questionnaires/${id}`, body),
    deleteQuestionnarie: async (id: string) =>
      await client.delete(`questionnaires/${id}`),
    getPermissionsOfTheQuestionaries: async ({
      id,
    }: {
      id: number
    }): Promise<PermissionQuestionnaireResponse> =>
      await client.get(`permissions/questionnaire/${id}`),
    createPermissions: async (body: ObjectGeneric) =>
      await client.post(`permissions`, body),
    getDetailQuestionnaireExecution: async ({ id, query }: { id?:string, query?: string }): Promise<QuetionarieDetail> => await client.get(`questionnaires/${id}/execution${query ? '?' + query : ''}`),
    getVersionQuestionaire: async ({ id, query }: { id?:string, query?: string }): Promise<Array<QuestionaireVersion>> => await client.get(`questionnaires/${id}/version${query ? '?' + query : ''}`),
    downloadFile: async (data: {
      type: `pdf` | 'word' | 'excel'
      query?: string
      id?: string
    }): Promise<GetBlob> =>
      await client.getBlob?.(
        `questionnaires/${data.id}/execution${data.query ? '?' + data.query + '&type=' + data.type: '?type=' + data.type}`
      ),
    downloadFileExtra: async (data: {
      type: `excel`
      query?: string
      id?: string
    }): Promise<GetBlob> =>
      await client.getBlob?.(
        `questionnaires/${data.id}/execution-answers${data.query ? '?' + data.query + '&type=' + data.type: '?type=' + data.type}`
      ),
  }
}
